module.exports = "/_next/static/images/loading_23-5143be2e4164962c9ea87fecb65d2438.png";